import { render } from "./toDoModal.vue?vue&type=template&id=5f0b1b38&scoped=true"
import script from "./toDoModal.vue?vue&type=script&lang=js"
export * from "./toDoModal.vue?vue&type=script&lang=js"

import "./toDoModal.vue?vue&type=style&index=0&id=5f0b1b38&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0b1b38"]])

export default __exports__